import { render, staticRenderFns } from "./NewReport.vue?vue&type=template&id=5b22befe&scoped=true&"
import script from "./NewReport.vue?vue&type=script&lang=js&"
export * from "./NewReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22befe",
  null
  
)

export default component.exports